// extracted by mini-css-extract-plugin
export default {"container":"styles_container__t8LyX","spiral__img":"styles_spiral__img__DvJ6I","hero__section__text":"styles_hero__section__text__vUq-0","waitList_btn":"styles_waitList_btn__mtq45"};